import { useMemo } from 'react'
import { useSlots as useSlotsLib } from '@bcraft-frontend-lib/slots'

import { deduplicateSlots } from 'modules/SlotsRoot/utils/deduplicateSlots'

import type { SlotPlace } from '../types/SlotPlace'

type UseSlotsParams = Parameters<typeof useSlotsLib<SlotPlace>>[0]

export const useSlots = (params: UseSlotsParams) => {
  const result = useSlotsLib<SlotPlace>(params)

  const list = useMemo(() => deduplicateSlots(result._slots.list), [result._slots.list])

  const listWithSlots = useMemo(
    () =>
      result._categories.listWithSlots.map(category => ({
        ...category,
        slots: deduplicateSlots(category.slots),
      })),
    [result._categories.listWithSlots],
  )

  return {
    ...result,
    _slots: {
      ...result._slots,
      list,
    },
    _categories: {
      ...result._categories,
      listWithSlots,
    },
  }
}
